/** ****
 * 接口域名列表
 * 不同包可能使用不同的域名，请项目接口域名使用全部来自这里，测试和线上都在这里
**** */
import updateLocation2 from './location2';
import { isWebZip } from './webzip';

const HTTPUrlMap = {
  joyu: {
    live: '//lvapi.joyu.live',
    live_test: '//featuremix-qa.joyu.live',
    baseUrl: 'https://lvapi.joyu.live'
  },
  sparkher: {
    live: '//lvapi.sparkher.cc',
    live_test: '//featuremix-qa.sparkher.cc',
    baseUrl: 'https://lvapi.sparkher.cc'
  },
  // chasex
  chasex: {
    live: '//lvapi.highlives.net',
    live_test: '//featuremix-qa.highlives.net',
    baseUrl: 'https://lvapi.highlives.net'
  },
  // 中东包
  arab: {
    live: '//live.liveme.com',
    live_test: '//featuremix-qa.live.liveme.com',
    baseUrl: 'https://live.liveme.com'
  },
  // 美包
  us: {
    live: '//live.aaalive.com',
    live_test: '//featuremix-qa.live.aaalive.com',
    baseUrl: 'https://live.liveme.com'
  },
  // cheez包
  cheez: {
    live: '//live.cheez.com',
    live_test: '//featuremix-qa.live.cheez.com',
    baseUrl: 'https://live.liveme.com'
  },
  // meet包
  meet: {
    live: '//live.liveme.com',
    live_test: '//featuremix-qa.live.liveme.com',
    baseUrl: 'https://live.liveme.com'
  },
  // pro包
  pro: {
    live: '//apipro.liveme.com',
    live_test: '//featuremix-qa.live.liveme.com',
    baseUrl: 'https://live.liveme.com'
  },
  // athena包
  athena: {
    live: '//apipro.liveme.com',
    live_test: '//featuremix-qa.live.liveme.com',
    baseUrl: 'https://live.liveme.com'
  },
  // 美国包
  livemeet: {
    live: '//lvapi.livemeet.tv',
    live_test: '//featuremix-qa.livemeet.tv',
    baseUrl: 'https://live.liveme.com'
  },
  // emolm(LiveMe+)包
  emolm: {
    live: '//lvapi.emolm.com',
    live_test: '//featuremix-qa.emolm.com',
    baseUrl: 'https://lvapi.emolm.com'
  },
  // highlive包
  highlive: {
    live: '//lvapi.highlives.net',
    live_test: '//featuremix-qa.highlives.net',
    baseUrl: 'https://lvapi.highlives.net'
  },
  // liveme主包
  liveme: {
    live: '//live.liveme.com',
    live_test: '//featuremix-qa.live.liveme.com',
    baseUrl: 'https://live.liveme.com'
  }
};

let HTTPUrl = {
  live: '',
  live_test: '',
  baseUrl: ''
};

if (window.KEWLApp && window.KEWLApp.getPackgetInfo) {
  const pack = window.KEWLApp.getPackgetInfo();
  HTTPUrl = HTTPUrlMap[pack] || HTTPUrlMap.liveme;
  // 兼容离线包
  if (isWebZip) {
    // HTTPUrl.live = `${window.location2.protocol}:${HTTPUrl.live}`;
    HTTPUrl.live = `https:${HTTPUrl.live}`;
    HTTPUrl.live_test = `${window.location2.protocol}${HTTPUrl.live_test}`;
  }
}

// 兼容coinsgame独立域名支持多包
// 根据getPackName获取包名
if (window.KEWLApp && window.KEWLApp.getPackName) {
  const packName = window.KEWLApp.getPackName();
  if (packName.split('.')[1]) {
    // eslint-disable-next-line prefer-destructuring
    const packForCoinsgame = packName.split('.')[1];
    HTTPUrl = HTTPUrlMap[packForCoinsgame] || HTTPUrlMap.liveme;
  }
}

console.log(HTTPUrl);
window.HTTPUrl = HTTPUrl;
